export const INVOICED = 'INVOICED';
export const ACTIVE = 'ACTIVE';
export const PENDING = 'PENDING';
export const UNKNOWN = 'UNKNOWN';
